import AppRoutes from "./AppRoutes";
import AppStore from "./AppStore";
import AppLinks from "./AppLinks";

export default {
  install(Vue, options) {
    options.router.addRoute(...AppRoutes.appRoutes);
    options.router.addRoute(...AppRoutes.appDashboardRoutes);
    options.router.addRoute(...AppRoutes.appDocumentRoutes);
    options.store.registerModule("Application", AppStore);
    options.store.commit("Dashboard/SET_LINKS", AppLinks);
  },
};
